module.exports = __webpack_public_path__ + "img/3.80c0c36b.png";